<div class="ui-account">
    <div class="ui-account-header">
        <div class="ui-account-container ui-account-header-container">
            <div class="ui-account-header-title">
                <span>Datos de la cuenta</span>
                <h1><small>Nº</small> {{user.client}}</h1>
            </div>

            <button mat-flat-button color="primary" class="ui-button" (click)="onUserdataForm()">Modificar contraseña</button>  
        </div>
    </div>
    
    <div class="ui-account-body">
        <form class="ui-account-container" [formGroup]="formData">
            <div class="ui-account-data">
                <h3 class="ui-title">Modificar datos de la cuenta </h3>
                
                <div class="ui-shadow ui-form">
                    <div class="ui-form-row">
                        <mat-form-field class="ui-input-firstname mat-form-field-readonly">
                            <mat-label>Nombre</mat-label>
                            <input matInput type="text" formControlName="firstname" readonly>
                            <mat-error *ngIf="formHasError('firstname', 'validate')">{{formHasError('firstname', 'message')}}</mat-error>
                        </mat-form-field>
                            
                        <mat-form-field class="ui-input-lastname mat-form-field-readonly">
                            <mat-label>Apellido</mat-label>
                            <input matInput type="text" formControlName="lastname" readonly>
                            <mat-error *ngIf="formHasError('lastname', 'validate')">{{formHasError('lastname', 'message')}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="ui-form-row">
                        <mat-form-field class="ui-input ui-input-dni mat-form-field-readonly">
                            <mat-label>DNI</mat-label>
                            <input matInput type="text" formControlName="dni" readonly>
                            <mat-error *ngIf="formHasError('dni', 'validate')">{{formHasError('dni', 'message')}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="ui-form-row">
                        <p>Para modificar estos datos es necesario solicitar un Cambio de Titularidad. Podes realizarlo iniciando una <a (click)="onNewProcedure()">nueva gestión</a>.</p>
                    </div>

                    <div class="ui-divider">Emails</div>            
                    
                    <div class="ui-list" formArrayName="emails">
                        <div [formGroupName]="i" class="ui-list-item ui-form-row" [ngClass]="{'ui-list-item-email': i == 0}" *ngFor="let control of emailsFields(); let i = index">
                            <mat-form-field class="ui-input ui-input-email">
                                <mat-label>Email <span *ngIf="i == 0">principal</span></mat-label>
                                <input matInput type="email" formControlName="email">
                                <mat-hint *ngIf="i == 0">Este email será utilizado como nombre de usuario para ingresar al panel de autogestión.</mat-hint>
                                <mat-error *ngIf="formHasError('email', 'validate') && i == 0">{{formHasError('email', 'message')}}</mat-error>
                            </mat-form-field>
                            
                            <button mat-button class="ui-list-item-remove ui-button" (click)="onEmailDelete(i)" *ngIf="i > 0"><mat-icon>close</mat-icon></button>
                        </div>

                        <div class="ui-list-footer">
                            <button mat-button class="ui-list-add ui-button" (click)="onEmailAdd()">Agregar email</button>
                        </div>
                    </div>                    

                    <div class="ui-divider">Telefonos</div>
                    
                    <div class="ui-list" formArrayName="phones">
                        <div [formGroupName]="i" class="ui-list-item ui-form-row" *ngFor="let control of phonesFields(); let i = index">                   
                            <div class="ui-input-phonegroup">                   
                                <mat-form-field class="ui-input ui-input-phonenumber">
                                    <mat-label>Teléfono</mat-label>
                                    <input matInput type="tel" formControlName="phoneNumber">
                                    <mat-error *ngIf="formHasError('phones.' + i + '.phoneNumber', 'validate')">{{formHasError('phones.' + i + '.phoneNumber', 'message')}}</mat-error>
                                </mat-form-field>

                                <mat-form-field class="ui-input ui-input-phonetype">
                                    <mat-label>Tipo</mat-label>
                                    <mat-select formControlName="phoneType">
                                        <mat-option value="Celular">Celular</mat-option>
                                        <mat-option value="Fijo">Fijo</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <button mat-button class="ui-list-item-remove ui-button" (click)="onPhoneDelete(i)" *ngIf="i > 0"><mat-icon>close</mat-icon></button>
                        </div>

                        <div class="ui-list-footer">
                            <button mat-button class="ui-list-add ui-button" (click)="onPhoneAdd()">Agregar teléfono</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="ui-account-data">
                <h3 class="ui-title">Domicilio de facturación</h3>
                
                <div class="ui-shadow ui-form">
                    <div *ngIf="!addressSame()">
                        <div class="ui-form-row">
                            <mat-form-field class="ui-input ui-input-state">
                                <mat-label>Provincia</mat-label>
                                <mat-select formControlName="addressBillingState" (selectionChange)="onDataChange('billing', 'state')">
                                    <mat-option *ngFor="let item of stateData" [value]="item.id">{{item.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formHasError('addressBillingState', 'validate')">{{formHasError('addressBillingState', 'message')}}</mat-error>
                            </mat-form-field>
                                
                            <mat-form-field class="ui-input ui-input-department">
                                <mat-label>Departamento</mat-label>
                                <mat-select formControlName="addressBillingDepartment" (selectionChange)="onDataChange('billing', 'department')">
                                    <mat-option *ngFor="let item of departmentBillingData" [value]="item.id">{{item.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formHasError('addressBillingDepartment', 'validate')">{{formHasError('addressBillingDepartment', 'message')}}</mat-error>
                            </mat-form-field>
                        </div>
                    
                        <div class="ui-form-row">
                            <mat-form-field class="ui-input ui-input-city">
                                <mat-label>Localidad</mat-label>
                                <mat-select formControlName="addressBillingCity">
                                    <mat-option *ngFor="let item of cityBillingData" [value]="item.id">{{item.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formHasError('addressBillingity', 'validate')">{{formHasError('addressBillingCity', 'message')}}</mat-error>
                            </mat-form-field>
                        </div>
                    
                        <div class="ui-form-row">
                            <mat-form-field class="ui-input ui-input-address">
                                <mat-label>Calle</mat-label>
                                
                                <input matInput type="text" placeholder="Buscar calle" formControlName="addressBillingStreet" [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="streetBillingNameGet.bind(this)">
                                    <mat-option *ngIf="streetLoading"><mat-spinner diameter="20"></mat-spinner></mat-option>
                                    <mat-option *ngFor="let item of streetBillingFilteredData | async" [value]="item.id">{{item.name}}</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="formHasError('addressBillingStreet', 'validate')">{{formHasError('addressBillingStreet', 'message')}}</mat-error>
                            </mat-form-field>
                    
                            <mat-form-field class="ui-input ui-input-addressnumber">
                                <mat-label>Número</mat-label>
                                <input matInput type="text" formControlName="addressBillingNumber">
                                <mat-error *ngIf="formHasError('addressBillingNumber', 'validate')">{{formHasError('addressBillingNumber', 'message')}}</mat-error>
                            </mat-form-field>
                    
                            <mat-form-field class="ui-input ui-input-addressapartment">
                                <mat-label>Piso y Departamento</mat-label>
                                <input matInput type="text" formControlName="addressBillingApartment">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="ui-form-row">
                        <mat-checkbox color="primary" formControlName="addressSame">Utilizar los mismo datos que el domicilio de conexión</mat-checkbox>
                    </div>
                </div> 
            </div> 
            
            <div class="ui-account-data">
                <h3 class="ui-title">Domicilio de conexión</h3>
                
                <div class="ui-shadow ui-form">
                    <div *ngIf="user.addressConectionUpdated">
                        <div class="ui-form-row">
                            <mat-form-field class="ui-input ui-input-state">
                                <mat-label>Provincia</mat-label>
                                <mat-select formControlName="addressConectionState" (selectionChange)="onDataChange('conection', 'state')">
                                    <mat-option *ngFor="let item of stateData" [value]="item.id">{{item.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formHasError('addressConectionState', 'validate')">{{formHasError('addressConectionState', 'message')}}</mat-error>
                            </mat-form-field>
                                
                            <mat-form-field class="ui-input ui-input-department">
                                <mat-label>Departamento</mat-label>
                                <mat-select formControlName="addressConectionDepartment" (selectionChange)="onDataChange('conection', 'department')">
                                    <mat-option *ngFor="let item of departmentConectionData" [value]="item.id">{{item.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formHasError('addressConectionDepartment', 'validate')">{{formHasError('addressConectionDepartment', 'message')}}</mat-error>
                            </mat-form-field>
                        </div>
                    
                        <div class="ui-form-row">
                            <mat-form-field class="ui-input ui-input-city">
                                <mat-label>Localidad</mat-label>
                                <mat-select formControlName="addressConectionCity">
                                    <mat-option *ngFor="let item of cityConectionData" [value]="item.id">{{item.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formHasError('addressConectionity', 'validate')">{{formHasError('addressConectionCity', 'message')}}</mat-error>
                            </mat-form-field>
                        </div>
                    
                        <div class="ui-form-row">
                            <mat-form-field class="ui-input ui-input-address">
                                <mat-label>Calle</mat-label>
                                <input matInput type="text" placeholder="Buscar calle" formControlName="addressConectionStreet" [matAutocomplete]="auto">
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="streetConectionNameGet.bind(this)">
                                    <mat-option *ngIf="streetLoading"><mat-spinner diameter="20"></mat-spinner></mat-option>
                                    <mat-option *ngFor="let item of streetConectionFilteredData | async" [value]="item.id">{{item.name}}</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="formHasError('addressConectionStreet', 'validate')">{{formHasError('addressConectionStreet', 'message')}}</mat-error>
                            </mat-form-field>
                    
                            <mat-form-field class="ui-input ui-input-addressnumber">
                                <mat-label>Número</mat-label>
                                <input matInput type="text" formControlName="addressConectionNumber">
                                <mat-error *ngIf="formHasError('addressConectionNumber', 'validate')">{{formHasError('addressConectionNumber', 'message')}}</mat-error>
                            </mat-form-field>
                    
                            <mat-form-field class="ui-input ui-input-addressapartment">
                                <mat-label>Piso y Departamento</mat-label>
                                <input matInput type="text" formControlName="addressConectionApartment">
                            </mat-form-field>
                        </div>
                    </div>
                    
                    <div class="ui-account-data-content" *ngIf="!user.addressConectionUpdated">
                        <p>
                            <strong>Dirección:</strong> {{this.user.addressConection.street.name}} {{user.addressConection.number}} {{user.addressConection.apartment}}<br>
                            <strong>Localidad:</strong> {{this.user.addressConection.city.name}}, {{user.addressConection.city.department.name}}, {{user.addressConection.city.state.name}}
                        </p>
                        <p>El domicilio de conexión esta vinculado a tus servicios, para modificarlo es necesario solicitar un traslado de los mismos. Podes realizarlo iniciando una nueva gestión.</p>
                        <button mat-stroked-button color="primary" class="ui-button" (click)="onNewProcedure()">Iniciar gestión</button>
                    </div>
                </div>  
            </div>

            <div class="ui-account-data" style="text-align:right;">
                <button mat-raised-button color="primary" (click)="onSave()" class="ui-button">Guardar cambios</button>
            </div>
        </form>
    </div>
</div>